/**
 * Il conto del progetto sul telefono (26/10/2026): le stesse cifre della scheda
 * "Quanto ci resta" del computer, in righe del kit mobile, dentro il gruppo Soldi.
 * Si legge soltanto: spese, agente e fatture si sistemano dal computer.
 */
import { useQuery } from '@tanstack/react-query';
import { MRow } from '../../components/mobile/MobileKit';
import { fmtEur } from '../../lib/utils';
import { contoQuery } from './projectsApi';

const euro = (n: number) => `€ ${fmtEur(n)}`;

export function ContoRigheMobile({ projectId }: { projectId: string }) {
  const { data: c } = useQuery(contoQuery(projectId));
  if (!c) return null;
  return (
    <>
      <MRow
        icon="percent"
        tone={c.resta < 0 ? 'alert' : undefined}
        title="Ci restano"
        sub={c.imponibile > 0 ? `${String(c.restaPct).replace('.', ',')}% del valore, dopo spese, provvigione e tasse` : 'manca il valore del lavoro'}
        trail={euro(c.resta)}
      />
      <MRow icon="receipt" title="Spese del progetto" sub={c.spese.righe.length ? `${c.spese.righe.length} ${c.spese.righe.length === 1 ? 'voce' : 'voci'}` : 'nessuna spesa inserita'} trail={euro(c.spese.totale)} trailTone={c.spese.totale ? undefined : 'mute'} />
      <MRow
        icon="handshake"
        title={c.provvigione.agente ? `Provvigione di ${c.provvigione.agente.nome}` : 'Provvigione'}
        sub={c.provvigione.agente ? `${String(c.provvigione.pct).replace('.', ',')}%, maturata ${euro(c.provvigione.maturata)}` : 'nessun agente'}
        trail={euro(c.provvigione.importo)}
        trailTone={c.provvigione.importo ? undefined : 'mute'}
      />
      <MRow icon="landmark" title="IRES e IRAP sull'utile" sub="stima sul singolo progetto" trail={euro(c.tasse.totale)} />
      <MRow icon="euro" title="IVA, va allo Stato" sub="il cliente la paga a noi, non è nostra" trail={euro(c.iva)} trailTone="mute" />
    </>
  );
}
